import { Box, Button, Container, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const BannerSection = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        py: { xs: 6, md: 8 },
        borderBottom: "1px solid rgba(0,0,0,0.06)",
      }}
    >
      <Container maxWidth="lg">
        <Box
          display="flex"
          flexDirection={{ xs: "column", md: "row" }}
          alignItems="center"
          justifyContent="space-between"
          gap={{ xs: 6, md: 10 }}
        >
          {/* LEFT CONTENT */}
          <Box flex={1}>
            <Typography
              variant="h2"
              fontWeight={800}
              gutterBottom
              sx={{
                lineHeight: 1.2,
                letterSpacing: "-0.5px",
              }}
            >
              Empower Your School
              <br />
              <Box component="span" color="primary.main">
                with MySchoolling
              </Box>
            </Typography>

            <Typography
              variant="h6"
              color="text.secondary"
              sx={{
                mt: 3,
                maxWidth: 520,
                lineHeight: 1.8,
              }}
            >
              A complete digital ecosystem that simplifies school management,
              enhances parent engagement, and empowers students with
              AI-powered learning support — all in one seamless platform.
            </Typography>

            <Box display="flex" gap={3} mt={5}>
              <Button
                variant="contained"
                size="large"
                sx={{
                  borderRadius: 3,
                  textTransform: "none",
                  fontWeight: 600,
                  px: 4,
                  py: 1.6,
                }}
                onClick={() => navigate("/contact")}
              >
                Request a Demo
              </Button>

              <Button
                variant="outlined"
                size="large"
                sx={{
                  borderRadius: 3,
                  textTransform: "none",
                  fontWeight: 600,
                  px: 4,
                  py: 1.6,
                }}
                onClick={() => navigate("/pricing")}
              >
                View Pricing
              </Button>
            </Box>
          </Box>

          {/* RIGHT IMAGE */}
          <Box
            flex={1}
            display="flex"
            justifyContent="center"
          >
            <Box
              component="img"
              src="/homebanner.png"
              alt="MySchoolling Dashboard"
              sx={{
                width: "100%",
                maxWidth: 500,
                borderRadius: 4,
                boxShadow: "0 30px 80px rgba(0,0,0,0.08)",
              }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default BannerSection;